import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {CustomFormsModule} from 'ng2-validation';
import {PipeModule} from '../../pipe/pipe.module';
import {AddressModule} from '../address/address.module';
import {BillingAccountComponent} from './billing-account.component';

@NgModule({
  imports: [AddressModule, CommonModule, CustomFormsModule, FormsModule, PipeModule],
  declarations: [BillingAccountComponent],
  exports: [BillingAccountComponent],
})
export class BillingAccountModule {}



// WEBPACK FOOTER //
// ./src/app/shared/ui/billing-account/billing-account.module.ts